import { useState } from 'react'
import { useMediaQuery } from '@helpers/hooks'
import { BREAKPOINT_SIZES } from '@consts/index'
import SectionHeader from '@components/ui/SectionHeader'
import Gallery from './Gallery'
import ProductCards from './ProductCards'
import styles from './styles.module.scss'

const MIX_AND_MATCH_DATA: MixAndMatchProps = {
  title: 'Meet Your Match',
  byline: 'Get kitted out',
  description:
    'The Enduro range was designed to create a 48 hour capsule — products that work effortlessly with each other to build a versatile spread of looks. So whether you’re on a work trip, a city break — or you just like getting dressed in the dark — we’ve made it easy.',
  products: {
    bottoms: [
      {
        title: 'Khaki',
        id: 0,
        category: 'bottoms',
        productType: 'Enduro Fives',
        handle: '/products/khaki-enduro-fives',
        thumbnail:
          '/static/images/enduros/mix-and-match/enduro-fives/khaki_fives_thumb.jpg',
        gallery: {
          mobile:
            '/static/images/enduros/mix-and-match/enduro-fives/khaki_fives_mobile.jpg',
          desktop:
            '/static/images/enduros/mix-and-match/enduro-fives/khaki_fives_desktop.jpg'
        }
      },
      {
        title: 'Navy',
        id: 1,
        productType: 'Enduro Fives',
        category: 'bottoms',
        handle: '/products/navy-enduro-fives',
        thumbnail:
          '/static/images/enduros/mix-and-match/enduro-fives/navy_fives_thumb.jpg',
        gallery: {
          mobile:
            '/static/images/enduros/mix-and-match/enduro-fives/navy_fives_mobile.jpg',
          desktop:
            '/static/images/enduros/mix-and-match/enduro-fives/navy_fives_desktop.jpg'
        }
      },
      {
        title: 'Nocturne',
        id: 2,
        productType: 'Enduro Fives',
        category: 'bottoms',
        handle: '/products/nocturne-enduro-fives',
        thumbnail:
          '/static/images/enduros/mix-and-match/enduro-fives/nocturne_fives_thumb.jpg',
        gallery: {
          mobile:
            '/static/images/enduros/mix-and-match/enduro-fives/nocturne_fives_mobile.jpg',
          desktop:
            '/static/images/enduros/mix-and-match/enduro-fives/nocturne_fives_desktop.jpg'
        }
      },
      {
        title: 'Dark Navy',
        id: 3,
        productType: 'Enduro Sharps',
        category: 'bottoms',
        handle: '/products/dark-navy-enduro-sharps',
        thumbnail:
          '/static/images/enduros/mix-and-match/enduro-sharps/navy_sharps_thumb.jpg',
        gallery: {
          mobile:
            '/static/images/enduros/mix-and-match/enduro-sharps/navy_sharps_mobile.jpg',
          desktop:
            '/static/images/enduros/mix-and-match/enduro-sharps/navy_sharps_desktop.jpg'
        }
      },
      {
        title: 'Petrol',
        id: 4,
        productType: 'Enduro Sharps',
        category: 'bottoms',
        handle: '/products/petrol-enduro-sharps',
        thumbnail:
          '/static/images/enduros/mix-and-match/enduro-sharps/petrol_sharps_thumb.jpg',
        gallery: {
          mobile:
            '/static/images/enduros/mix-and-match/enduro-sharps/petrol_sharps_mobile.jpg',
          desktop:
            '/static/images/enduros/mix-and-match/enduro-sharps/petrol_sharps_desktop.jpg'
        }
      },
      {
        title: 'Wren',
        id: 5,
        productType: 'Enduro Sharps',
        category: 'bottoms',
        handle: '/products/wren-enduro-sharps',
        thumbnail:
          '/static/images/enduros/mix-and-match/enduro-sharps/wren_sharps_thumb.jpg',
        gallery: {
          mobile:
            '/static/images/enduros/mix-and-match/enduro-sharps/wren_sharps_mobile.jpg',
          desktop:
            '/static/images/enduros/mix-and-match/enduro-sharps/wren_sharps_desktop.jpg'
        }
      }
    ],
    tops: [
      {
        title: 'Night Race',
        id: 0,
        productType: 'Enduro T-Shirt',
        category: 'tops',
        handle: '/products/night-race-enduro-t-shirt',
        thumbnail:
          '/static/images/enduros/mix-and-match/enduro-t-shirt/blue_tshirt_thumb.jpg',
        gallery: {
          mobile:
            '/static/images/enduros/mix-and-match/enduro-t-shirt/blue_tshirt_mobile.jpg',
          desktop:
            '/static/images/enduros/mix-and-match/enduro-t-shirt/blue_tshirt_desktop.jpg'
        }
      },
      {
        title: 'Tawny',
        id: 1,
        productType: 'Enduro T-Shirt',
        category: 'tops',
        handle: '/products/tawny-enduro-t-shirt',
        thumbnail:
          '/static/images/enduros/mix-and-match/enduro-t-shirt/port_tshirt_thumb.jpg',
        gallery: {
          mobile:
            '/static/images/enduros/mix-and-match/enduro-t-shirt/port_tshirt_mobile.jpg',
          desktop:
            '/static/images/enduros/mix-and-match/enduro-t-shirt/port_tshirt_desktop.jpg'
        }
      },
      {
        title: 'White',
        id: 2,
        productType: 'Enduro T-Shirt',
        category: 'tops',
        handle: '/products/white-enduro-t-shirt',
        thumbnail:
          '/static/images/enduros/mix-and-match/enduro-t-shirt/white_tshirt_thumb.jpg',
        gallery: {
          mobile:
            '/static/images/enduros/mix-and-match/enduro-t-shirt/white_tshirt_mobile.jpg',
          desktop:
            '/static/images/enduros/mix-and-match/enduro-t-shirt/white_tshirt_desktop.jpg'
        }
      },
      {
        title: 'Dark Chambray',
        id: 3,
        productType: 'Enduro Shirt',
        category: 'tops',
        handle: '/products/dark-chambray-enduro-shirt',
        thumbnail:
          '/static/images/enduros/mix-and-match/enduro-shirt/chambray_shirt_thumb.jpg',
        gallery: {
          mobile:
            '/static/images/enduros/mix-and-match/enduro-shirt/chambray_shirt_mobile.jpg',
          desktop:
            '/static/images/enduros/mix-and-match/enduro-shirt/chambray_shirt_desktop.jpg'
        }
      },
      {
        title: 'White',
        id: 4,
        productType: 'Enduro Shirt',
        category: 'tops',
        handle: '/products/white-enduro-shirt',
        thumbnail:
          '/static/images/enduros/mix-and-match/enduro-shirt/white_shirt_thumb.jpg',
        gallery: {
          mobile:
            '/static/images/enduros/mix-and-match/enduro-shirt/white_shirt_mobile.jpg',
          desktop:
            '/static/images/enduros/mix-and-match/enduro-shirt/white_shirt_desktop.jpg'
        }
      }
    ]
  }
}

type MixAndMatchProps = {
  title: string
  byline: string
  description: string
  products: {
    bottoms: MixAndMatchProduct[]
    tops: MixAndMatchProduct[]
  }
}

export type MixAndMatchProduct = {
  title: string
  id: number
  category: string
  productType: string
  handle: string
  thumbnail: string
  gallery: {
    mobile: string
    desktop: string
  }
}

type HeaderProperties = {
  title: string
  description: string
}

const Header = ({ title, description }: HeaderProperties) => {
  return (
    <>
      <SectionHeader
        title={title}
        variant="left_aligned"
        className={styles.mixAndMatch__SectionHeader}
      />
      <p>{description}</p>
    </>
  )
}

export default function MixAndMatch() {
  const { title, description, products } = MIX_AND_MATCH_DATA
  const isDesktop = useMediaQuery({
    minWidth: BREAKPOINT_SIZES.DESKTOP,
    initialState: true
  })

  const [activeCategory, setActiveCategory] = useState({
    tops: 0,
    bottoms: 0
  })

  return (
    <div className={styles.mixAndMatch}>
      <div className={styles.mixAndMatchWrapper}>
        {!isDesktop ? (
          <>
            <div className={styles.mixAndMatch__Header}>
              <Header title={title} description={description} />
            </div>
            <div className={styles.mixAndMatch__ContentWrapper}>
              <Gallery
                products={products}
                setActiveCategory={setActiveCategory}
              />
              <ProductCards
                products={products}
                activeCategory={activeCategory}
              />
            </div>
          </>
        ) : (
          <>
            <Gallery
              products={products}
              setActiveCategory={setActiveCategory}
            />
            <div className={styles.mixAndMatch__ProductCards}>
              <Header title={title} description={description} />
              <ProductCards
                products={products}
                activeCategory={activeCategory}
              />
            </div>
          </>
        )}
      </div>
    </div>
  )
}
